import { render, staticRenderFns } from "./AppointmentCardNew.vue?vue&type=template&id=52aadcf0&scoped=true"
import script from "./AppointmentCardNew.vue?vue&type=script&lang=js"
export * from "./AppointmentCardNew.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCardNew.vue?vue&type=style&index=0&id=52aadcf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aadcf0",
  null
  
)

export default component.exports